"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCorsOrNetworkError = exports.getServerHtmlMessage = void 0;
const constants_1 = require("@/app/shared/constants");
const getServerHtmlMessage = (error) => {
    const axiosError = error;
    const status = axiosError?.response?.status;
    if (String(status) !== constants_1.STANDARD_ERROR_CODES.NO_PERMISSIONS)
        return null;
    const message = axiosError?.response?.data?.message;
    return typeof message === 'string' && message.trim().length > 0 ? message : null;
};
exports.getServerHtmlMessage = getServerHtmlMessage;
const isCorsOrNetworkError = (error) => {
    const axiosError = error;
    if (axiosError?.response)
        return false;
    const message = (error instanceof Error ? error.message : String(error ?? '')).toLowerCase();
    return (error instanceof TypeError ||
        message.includes('failed to fetch') ||
        message.includes('networkerror') ||
        message.includes('network error'));
};
exports.isCorsOrNetworkError = isCorsOrNetworkError;
